import React from 'react';

import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import FiberManualRecordOutlinedIcon from '@mui/icons-material/FiberManualRecordOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { arrayOf, shape } from 'prop-types';

import formatAddress from '../../../utils/formatAddress';

const Locations = ({ locations }) => (
  <Box>
    {locations?.map((location, i) => (
      <Box mb={1} key={location.id}>
        <Box mt={i !== 0 ? -1 : 0} display='flex' alignItems='flex-start'>
          {i === locations.length - 1 ? (
            <LocationOnOutlinedIcon color='secondary' />
          ) : (
            <FiberManualRecordOutlinedIcon color='secondary' />
          )}
          <Box pl={1} maxWidth='calc(100% - 35px)'>
            <Typography noWrap>
              {formatAddress({
                line1: location.street_address_1,
                line2: location.street_address_2,
                city: location.city,
                region: location.state,
                postalCode: location.postal_id,
              })}
            </Typography>
          </Box>
        </Box>
        {i !== locations.length - 1 && (
          <Box
            sx={{
              mt: -2,
              pl: 1.15,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                mt: 1,
              }}
            >
              <FiberManualRecordIcon
                sx={{
                  color: (theme) => theme.palette.neutral.light,
                  height: 6,
                  width: 6,
                  mb: 0.5,
                  mt: 0.75,
                }}
              />
              <FiberManualRecordIcon
                sx={{
                  color: (theme) => theme.palette.neutral.light,
                  height: 6,
                  width: 6,
                  mb: 0.5,
                }}
              />
            </Box>
          </Box>
        )}
      </Box>
    ))}
  </Box>
);

Locations.propTypes = {
  locations: arrayOf(shape({})).isRequired,
};

export default Locations;
